import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { sectionVariant, viewportOnce } from '@/lib/motion';

/**
 * FormContainer - Wrapper component for all forms
 * 
 * Design:
 * - White background
 * - No shadows, no gradients
 * - Clean labels
 * - Generous spacing
 */

interface FormContainerProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

const FormContainer = ({ 
  title, 
  description, 
  children, 
  className = '' 
}: FormContainerProps) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={sectionVariant}
      className={`bg-background ${className}`}
    >
      <div className="mb-8">
        <h2 className="font-display text-2xl md:text-3xl font-semibold text-foreground mb-3">
          {title}
        </h2>
        {description && (
          <p className="text-muted-foreground leading-relaxed max-w-xl">
            {description}
          </p>
        )}
      </div>
      {children}
    </motion.div>
  );
};

export default FormContainer;
